import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RecallVinSearchPage.scss';
import classNames from 'classnames';

// Components
import { Container, Row, Col } from 'reactstrap';
import AppointmentFlowWizard from 'components/templates/AppointmentFlowWizard/';
import AppointmentFlowFooter from 'components/molecules/AppointmentFlowFooter/';
import AppointmentFlowHeader from 'components/molecules/AppointmentFlowHeader/';
import Button from 'components/atoms/Button';
import InputField from 'components/atoms/InputField';
import Modal from 'components/atoms/Modal';
import WhereIsMyVin from 'components/molecules/WhereIsMyVin';
import VehicleImageWithPlaceholder from 'components/atoms/VehicleImageWithPlaceholder';
import Media from 'react-media';

// Constants
import { RECALL_SERVICES_ROUTE, SERVICES_ROUTE } from 'constants/routes';
import { APP_BREAKPOINTS } from 'constants/appConfig';

// Utils
import * as vehicleUtils from 'utils/vehicle';
import { getVehicleImgUrl } from 'utils/media';
import { ALPHA_NUMERIC_REGEX } from 'utils/regex';

const ns = 'recall-vin-search-page';

class RecallVinSearchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVIN: '',
      searchingVIN: false,
      invalidVIN: false,
      decodedVehicle: {},
      updateVehicleView: false,
      noAutoRecallsFound: false
    };
    this.onSearchVIN = this.onSearchVIN.bind(this);
    this.onUpdateVehicle = this.onUpdateVehicle.bind(this);
    this.onChangeInputSearch = this.onChangeInputSearch.bind(this);
    this.searchRecalls = this.searchRecalls.bind(this);
    this.searchHandler = this.searchHandler.bind(this);
    this.VINModal = React.createRef();
    this.missMatchingModal = React.createRef();
    this.inputSearch = React.createRef();
  }

  componentDidMount() {
    this.inputSearch.current.input.focus();
  }

  onClickWhereIsMyVIN = () => {
    this.VINModal.current.setShowModal(true);
  };

  showMissMatchingModal = show => {
    this.missMatchingModal.current.setShowModal(show);
    if (!show) {
      this.setState({
        updateVehicleView: false
      });
    }
  };

  onUpdateVehicle = () => {
    this.setState({
      updateVehicleView: true
    });
  };

  onSearchVIN = async () => {
    const { searchVIN } = this.state;
    if (searchVIN.length !== 17) {
      this.setState({
        invalidVIN: true,
        noAutoRecallsFound: false
      });
      return;
    }
    this.setState({
      searchingVIN: true,
      invalidVIN: false,
      noAutoRecallsFound: false
    });

    const decodedVIN = await this.decodeVIN(searchVIN);
    if (decodedVIN) {
      this.setState({
        decodedVehicle: {
          ...vehicleUtils.formatedVehicleObj(decodedVIN),
          vin: searchVIN
        }
      });
      await this.compareVehicleData();
    } else {
      this.setState({
        invalidVIN: true
      });
    }
    this.setState({
      searchingVIN: false
    });
  };

  searchHandler = async e => {
    e.preventDefault();
    this.inputSearch.current.input.blur();
    return this.onSearchVIN();
  };

  decodeVIN = async searchVIN => {
    try {
      const { getDecodeVIN } = this.props;
      return await getDecodeVIN(searchVIN);
    } catch (e) {
      this.setState({
        searchingVIN: false
      });
      /* eslint-disable no-console */
      console.error(e);
      /* eslint-enable no-console */
      return null;
    }
  };

  compareVehicleData = async () => {
    const { vehicle } = this.props;
    const { decodedVehicle } = this.state;
    if (
      !vehicleUtils.compareMYM(
        vehicleUtils.formatedVehicleObj(vehicle),
        decodedVehicle
      )
    ) {
      this.setState({
        invalidVIN: true
      });
    } else if (
      !vehicleUtils.compareMYMT(
        vehicleUtils.formatedVehicleObj(vehicle),
        decodedVehicle
      )
    ) {
      this.showMissMatchingModal(true);
    } else {
      await this.searchRecalls();
    }
  };

  searchRecalls = async () => {
    const { decodedVehicle } = this.state;
    const { currentMileage, setCustomerVehicle } = this.props;
    this.showMissMatchingModal(false);
    await setCustomerVehicle({ mileage: currentMileage, ...decodedVehicle });
    this.recallsLoaded();
  };

  recallsLoaded = () => {
    const { autoRecalls, goTo } = this.props;
    if (autoRecalls.length === 0) {
      this.setState({
        noAutoRecallsFound: true
      });
    } else {
      goTo(RECALL_SERVICES_ROUTE);
    }
  };

  onChangeInputSearch = searchVIN => {
    this.setState({
      searchVIN
    });
  };

  cancelUpdateVehicle = () => {
    this.setState({
      updateVehicleView: false
    });
  };

  getVehicleLabel = ({ year, make, model, trim }) => {
    return `${year} ${make} ${model} ${trim || ''}`;
  };

  getVehicleSearchRow = vehicle => {
    const { dealerCountryCode } = this.props;
    return (
      <Row className={`${ns}__vehicle-search-option`}>
        <Col className={`${ns}__vehicle-image-wrapper p-0`}>
          <VehicleImageWithPlaceholder
            src={getVehicleImgUrl(vehicle, dealerCountryCode)}
          />
        </Col>
        <Col className={`${ns}__vehicle-name-label`}>
          {this.getVehicleLabel(vehicle)}
        </Col>
      </Row>
    );
  };

  getMissMatchingView = () => {
    const { updateVehicleView, decodedVehicle } = this.state;
    const { vehicle, intl } = this.props;
    if (!updateVehicleView) {
      return (
        <Container>
          <div className={`${ns}__modal-title text-center`}>
            {intl.formatMessage({
              id: 'c8.recall.search.page.mismatch.modal.title'
            })}
          </div>
          <div className={`${ns}__miss-matching-vehicle-wrapper`}>
            <div className={`${ns}__original-vehicle-label p-0`}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.mismatch.modal.original.vehicle'
              })}
            </div>
            {this.getVehicleSearchRow(vehicle)}
            <Button onClick={event => this.showMissMatchingModal(false)}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.mismatch.modal.button.keep.vehicle'
              })}
            </Button>
          </div>
          <div className={`${ns}__miss-matching-vehicle-wrapper`}>
            <div className={`${ns}__suggested-vehicle-label p-0`}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.mismatch.modal.suggested.vehicle'
              })}
            </div>
            {this.getVehicleSearchRow(decodedVehicle)}
            <Button
              className={`${ns}__update-btn-first-step`}
              onClick={event => this.onUpdateVehicle()}
            >
              {intl.formatMessage({
                id: 'c8.recall.search.page.mismatch.modal.button.update'
              })}
            </Button>
          </div>
          <div className={`${ns}__change-vehicle-message`}>
            {intl.formatMessage({
              id: 'c8.recall.search.page.mismatch.modal.warning.label'
            })}
          </div>
        </Container>
      );
    } else {
      return (
        <div className={'d-flex align-items-center flex-column'}>
          <div className={`${ns}__modal-title text-center`}>
            {intl.formatMessage({
              id: 'c8.recall.search.page.mismatch.modal.confirm.update.title'
            })}
          </div>
          <Button
            className={`${ns}__update-btn`}
            onClick={event => this.searchRecalls()}
          >
            {intl.formatMessage({
              id: 'c8.recall.search.page.mismatch.modal.confirm.update.button'
            })}
          </Button>
          <Button
            buttonTheme="link"
            onClick={() => this.cancelUpdateVehicle()}
            className={`${ns}__cancel-btn`}
          >
            {intl.formatMessage({
              id: 'c8.common.cancel'
            })}
          </Button>
        </div>
      );
    }
  };

  getStatusSearch = () => {
    const { intl } = this.props;
    const {
      noAutoRecallsFound,
      invalidVIN,
      decodedVehicle,
      searchingVIN
    } = this.state;
    const { make, year, model } = decodedVehicle;
    if (searchingVIN) {
      return (
        <div className={`${ns}__searching-message`}>
          {intl.formatMessage({
            id: 'c8.recall.search.page.label.searching'
          })}
        </div>
      );
    }
    if (noAutoRecallsFound) {
      return (
        <div className={`${ns}__no-results-wrapper`}>
          <div className={`${ns}__no-results-check`} />
          <div className={`${ns}__no-results-message`}>
            {intl.formatMessage({
              id: 'c8.recall.search.page.label.no.recalls.found.message'
            })}
          </div>
          <div className={`${ns}__no-results-vehicle`}>
            {intl.formatMessage(
              { id: 'c8.recall.search.page.label.no.recalls.found.vehicle' },
              { make, year, model }
            )}
          </div>
        </div>
      );
    }
    if (invalidVIN) {
      return (
        <div className={`${ns}__invalid-vin-message`}>
          {intl.formatMessage({
            id: 'c8.recall.search.page.label.invalid.vin'
          })}
        </div>
      );
    }
  };

  render() {
    const { intl } = this.props;
    const { searchingVIN, invalidVIN } = this.state;
    const inputConf = {
      name: 'vin_search',
      onChange: ({ target: { value } }) => this.onChangeInputSearch(value)
    };
    const inputClassNames = classNames(`${ns}__input-field search-input`, {
      [`${ns}--input-file-error`]: invalidVIN,
      loading: searchingVIN
    });
    const ariaCloseId = 'c8.aria.close.vin.modal';
    const ariaCloseDefault = 'Close VIN Modal';
    return (
      <AppointmentFlowWizard
        className={`${ns} ${ns}__footer-hidden`}
        header={() => (
          <AppointmentFlowHeader
            label={intl.formatMessage({
              id: 'c8.header.services'
            })}
            routeTo={SERVICES_ROUTE}
            backButtonAriaLabel={intl.formatMessage({
              id: 'c8.aria.back.to.services',
              defaultMessage: 'Back to services'
            })}
          />
        )}
        footer={() => (
          <Media query={`(max-width: ${APP_BREAKPOINTS.SM}px)`}>
            <AppointmentFlowFooter
              buttonText={intl.formatMessage({
                id: 'c8.common.search'
              })}
              onClick={() => this.onSearchVIN()}
            />
          </Media>
        )}
        body={() => (
          <Container>
            <Modal
              size="large"
              ref={this.VINModal}
              title={() => (
                <div>
                  {intl.formatMessage({
                    id: 'c8.recall.search.page.vin.modal.title'
                  })}
                </div>
              )}
              ariaCloseId={ariaCloseId}
              ariaCloseDefault={ariaCloseDefault}
            >
              <WhereIsMyVin />
            </Modal>
            <Modal
              ref={this.missMatchingModal}
              size="large"
              ariaCloseId={ariaCloseId}
              ariaCloseDefault={ariaCloseDefault}
            >
              {this.getMissMatchingView()}
            </Modal>
            <h1 className={`${ns}__title`}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.title'
              })}
            </h1>
            <div className={`${ns}__label`}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.subtitle.enter.vin'
              })}
            </div>
            <Row className={`${ns}__row`} tabIndex={0}>
              <Col sm={12} md={6}>
                <form onSubmit={this.searchHandler}>
                  <InputField
                    ref={this.inputSearch}
                    type={'search'}
                    className={inputClassNames}
                    placeholder={intl.formatMessage({
                      id: 'c8.recall.search.page.input.placeholder'
                    })}
                    inputConf={inputConf}
                    maskReg={ALPHA_NUMERIC_REGEX}
                    tabIndex={0}
                    inputAriaLabel={intl.formatMessage({
                      id: 'c8.recall.search.page.input.placeholder'
                    })}
                  />
                </form>
                {this.getStatusSearch()}
              </Col>
              <Col sm={12} md={6} className="text-right">
                <Button
                  buttonTheme="link"
                  className={`${ns}__wheres-my-vin-link`}
                  onClick={e => this.onClickWhereIsMyVIN()}
                  tabIndex={0}
                >
                  {intl.formatMessage({
                    id: 'c8.recall.search.page.button.where.is.my.vin'
                  })}
                </Button>
              </Col>
              <Col sm={12} md={6}>
                <Button
                  onClick={this.onSearchVIN}
                  className={`${ns}__search-btn d-none d-md-block`}
                  aria-label={intl.formatMessage({
                    id: 'c8.aria.search.button',
                    defaultMessage: 'Search button'
                  })}
                  tabIndex={0}
                >
                  {intl.formatMessage({ id: 'c8.common.search' })}
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      />
    );
  }
}

RecallVinSearchPage.propTypes = {
  autoRecalls: PropTypes.array,
  dealerCountryCode: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  vehicle: PropTypes.object
};

export default RecallVinSearchPage;



// WEBPACK FOOTER //
// ./src/components/pages/RecallVinSearchPage/RecallVinSearchPage.js